<template>
  <v-card>
    <v-card-title v-if="insideDialog">
      <span class="text-h5 mb-2">New Task</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              label="Assign User"
              v-model="assignedUser"
              :items="assignmentList"
              :loading="assignmentLoading"
              :search-input.sync="assignmentSearch"
              :readonly="section === 'authorization'"
              item-text="username"
              return-object
              clearable
              required
              :rules="[assignedUser != null || 'Assignment is required']"
              outlined
              dense
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title> {{ item.username }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.userID }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              label="Task result"
              v-model="taskResult"
              :items="taskResultList"
              :readonly="section === 'authorization'"
              item-text="result"
              clearable
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            Task Priority
            <v-radio-group
              v-model="taskPriority"
              required
              :rules="[taskPriority != '' || 'Priority is required']"
              row
            >
              <v-radio label="Low" value="Low"></v-radio>
              <v-radio label="Medium" value="Medium"></v-radio>
              <v-radio label="High" value="High"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="taskObjective"
              label="Please enter the task objective"
              :counter="255"
              dense
              outlined
              :rules="[
                taskObjective != '' || 'Objective is required',
                (v) => v.length <= 255 || 'Max 255 characters',
              ]"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn color="accent" text @click="closeNewNote()"> Cancel </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" text @click="validate()"> Create </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NewTask',
  props: ['user', 'section', 'enrolleeID', 'insideDialog'],
  data() {
    return {
      dialog: false,
      valid: false,
      assignedUser: null,
      assignmentList: [],
      assignmentLoading: false,
      assignmentSearch: null,
      taskResultList: [],
      taskResult: false,
      taskType: 'Follow up',
      taskPriority: '',
      taskObjective: '',
      taskAuthID: '',
    };
  },
  mounted() {
    this.getUsers();
    this.getTaskResultList();
  },
  methods: {
    async getUsers() {
      try {
        await axios.get('/api/search/users/all/').then((response) => {
          this.assignmentList = response.data;
          this.assignmentLoading = false;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getTaskResultList() {
      try {
        await axios.get('/api/tasks/taskResultList/').then((response) => {
          this.taskResultList = response.data;
        });
      } catch (e) {
        console.log(e);
      }
    },

    validate() {
      console.log(this.taskResult);
      if (this.$refs.form.validate()) {
        this.saveTask();
      }
    },
    async saveTask() {
      /*
        In enrollments a 'Follow up' task can be created when a new note is created on that enrollment.
        If the user checks to create a followup then this component shows.
        When creating a followup, we validate the task here and emit it to it's parent component
        The parent component then validates its note. Both note and task have to be validated for either to go through
        if one is invalid, neither gets created
      */
      console.log(this.taskResult);

      const newTask = {
        AssignedTo: this.assignedUser,
        TaskType: this.taskType,
        TaskPriority: this.taskPriority,
        TaskObjective: this.taskObjective,
        TaskAuthID: this.taskAuthID,
        TaskPatientID: this.enrolleeID,
        taskResult: this.taskResult,
      };
      console.log(this.taskResult);
      console.log(newTask);

      if (!this.insideDialog) {
        this.$emit('addNewNote', newTask);
      } else {
        // create task without note
        await axios
          .post('/api/tasks/new', [newTask])
          .then(() => {
            this.$emit('closeDialog', true);
            this.clearTask();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    clearTask() {
      this.assignedUser = {};
      this.taskResult = {};
      this.taskPriority = '';
      this.taskObjective = '';
      this.dialog = false;
    },
    setAuthID(value) {
      this.taskAuthID = value.AuthID;
    },
    closeNewNote() {
      if (!this.insideDialog) {
        this.$emit('closeNewNote');
      } else {
        this.clearTask();
        this.$emit('closeDialog');
      }
    },
  },
  computed: {
    showTaskAuthId() {
      if (this.section === 'authorization' || this.taskType === 'Authorization Alert') {
        return true;
      }
      return false;
    },
    typeList() {
      return ['Follow up'];
    },

  },
  watch: {
    dialog() {
      if (this.dialog) {
        switch (this.section) {
          case 'authorization':
            this.assignmentList.push(this.auth.AssignedUser);
            this.assignedUser = this.auth.AssignedUser;
            this.taskAuthID = this.auth.AuthID;
            break;
          default:
            this.assignedUser = null;
        }
      }
    },
    // assignmentSearch() {
    //   if (this.assignmentSearch !== null) {
    //     this.assignmentLoading = true;
    //
    //     // Lazily load input items
    //
    //   }
    // },
  },
};
</script>
